module.exports = __webpack_public_path__ + "img/full2-min.ad116a87.png";